<template>
    <div class="auth-wrap">
        <div class="glass auth-card" style="text-align:center">
            <div class="mono" style="font-size:4.5rem;font-weight:700;letter-spacing:-0.04em;background:linear-gradient(100deg,var(--accent),var(--accent-2));-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent">404</div>
            <h1 class="auth-title" style="margin-top:4px">Page not found</h1>
            <p class="auth-sub">The route you followed doesn't exist — or you don't have access to it.</p>
            <a class="btn btn--primary" href="/">← Back to safety</a>
        </div>
    </div>
</template>
<script>

export default {
    name: 'PageNotFound',
}
</script>
